import { render } from "./KioskLogin.vue?vue&type=template&id=1ea48eb2"
import script from "./KioskLogin.vue?vue&type=script&lang=js"
export * from "./KioskLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__